// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"585":"508c20c3","600":"a950d9ee"}[chunkId] + ".chunk.css";
};